import Environment from '../common/Environment';
import Group from '../entities/Group';
import Member from '../entities/Member';
import GroupJson from '../jsons/GroupJson';

export default class PostGroup {
  execute(group: Group, account: Member): Promise<Group> {
    const method: string = 'POST';
    const path = Environment.server() + '/group';

    return new Promise((resolve, reject) => {
      fetch(path, {
        method,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          account,
          group
        })
      })
        .then((response: Response) => {
          if (response.ok) {
            return response.json();
          } else {
            reject(response.status);
            return null;
          }
        })
        .then((responseJson: GroupJson) => {
          if (
            responseJson.api === undefined ||
            responseJson.api.status === undefined
          ) {
            reject('Server Error');
          } else if (responseJson.api.status === 'success') {
            resolve(responseJson.group);
          } else {
            reject(responseJson.api.errorMessage);
          }
        })
        .catch(error => {
          console.log(error.message);
          reject(
            `通信に失敗しました。ネットワークに問題がある可能性があります。\n${error.message}`
          );
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/apis/PostGroup.ts